import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Book } from "@/components/BookCard";

const BOOK_COLUMNS = "id, title, author, price, cover_url, type, stock_quantity, description, sort_order, is_published, stripe_price_id, is_preorder, compare_at_price, slug";

export const useBooks = () => {
  return useQuery({
    queryKey: ["books", "published"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("books")
        .select(BOOK_COLUMNS)
        .eq("is_published", true)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data ?? []) as Book[];
    },
  });
};
